import { Accomodation } from './get'


export const URL = '/v2/pms/accomodations/'

export type Req = {
  accom_type: string
  name: string
  city: number
  address: string
  latitude: number
  longitude: number
}

export type Resp = Accomodation
